import { AfterContentInit, ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { LogService } from "@nts/std/utility";
import { ComponentLocator } from "../../component-locator";
import { CustomFieldComponentInterface } from "../core/custom-field/custom-field-component.interface";
import { BehaviorSubject } from "rxjs";
import { ClassConstructor } from "@nts/std/serialization";
import type { CoreOrchestratorViewModelInterface, CustomFieldMetaDataInterface } from '@nts/std/interfaces';

@UntilDestroy()
@Component({
  selector: 'nts-custom-field-container',
  templateUrl: './custom-field-container.component.html',
  styleUrls: ['./custom-field-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldContainerComponent implements OnInit, AfterContentInit {

  #isDisabled = new BehaviorSubject<boolean>(false);

  @ViewChild('customComponentPlaceHolder', { read: ViewContainerRef, static: true })
  customComponentPlaceHolder: ViewContainerRef;

  @HostBinding('class.additional-field')
  @Input() additionalField = false;

  @HostBinding('class.full-column')
  @Input() fullColumn = false;

  @HostBinding('class.is-hidden')
  @Input() isHidden = false;

  @Input() metaData: CustomFieldMetaDataInterface;

  @Input() ovm: CoreOrchestratorViewModelInterface;

  @Input()
  set isDisabled(value: boolean) {
    this.#isDisabled.next(value);
  }
  get isDisabled() {
    return this.#isDisabled.value;
  }

  customComponentType: ClassConstructor<CustomFieldComponentInterface>;
  customComponentInstance$ = new BehaviorSubject<CustomFieldComponentInterface>(null);

  get uniqueId() {
    return this.customComponentInstance$.value?.uniqueId;
  }

  get type() {
    return this.customComponentInstance$.value?.type;
  }

  get path() {
    return this.customComponentInstance$.value?.path;
  }

  get name() {
    return this.customComponentInstance$.value?.name;
  }

  get description() {
    return this.customComponentInstance$.value?.description;
  }

  get displayName() {
    return this.customComponentInstance$.value?.displayName;
  }

  constructor(
    private readonly componentLocator: ComponentLocator,
  ) {

  }

  ngOnInit(): void {
    this.initCustomComponentFromMetaData();
  }

  initCustomComponentFromMetaData() {
    this.customComponentType = this.componentLocator.getCustomComponentType(this.metaData.uniqueId);
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  async ngAfterContentInit() {
    this.customComponentPlaceHolder.clear();
    this.initCustomComponentFromMetaData();
    if (this.customComponentType) {
      const componentRef = this.customComponentPlaceHolder.createComponent(this.customComponentType);
      this.customComponentInstance$.next(componentRef.instance);
      this.customComponentInstance$.value.initComponentFromMetaData(this.metaData, this.ovm);
      this.#isDisabled.pipe(untilDestroyed(this)).subscribe(value => {
        this.customComponentInstance$.value.isDisabled = value;
      });
    } else {
      LogService.warn('customComponentType con codice ' + this.metaData.uniqueId + ' non trovato!');
    }
    return Promise.resolve();
  }
}
